<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.id"
        placeholder="请输入ID"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-input
        v-model="params.name"
        placeholder="请输入专题名称"
        clearable
        size="small"
        class="param-input"
        style="width: 280px"
      ></el-input>
      <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择是否推荐"
        clearable
        size="small"
        v-model="params.isRecommend"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in isRecommendes"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择模块"
        clearable
        size="small"
        v-model="params.cid">
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="item in modulesList"
          :key="item.id"></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading1"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="专题名称"
        align="center"
        width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="专题类型" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type == 1">合集</el-tag>
          <el-tag type="success" v-if="scope.row.type == 2">排行榜</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="showType"
        label="专题样式"
        align="center"
        width="150">
        <template slot-scope="scope">
          <el-tag type="success">{{ getShowTypeName(scope.row.showType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="所属模块名称"
        align="center"
        width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.cName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isRecommend"
        label="是否推荐"
        align="center"
        width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isRecommend">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="是否开启" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="collectionLimit"
        label="数量限制"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.collectionLimit || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="openAddPlaylist(scope.row)"
            >添加</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @before-close="handleClose"
      @close="handleClose">
      <el-form :model="form" label-width="120px" :rules="rules" ref="form">
        <el-form-item label="所属模块:" style="width: 480px" size="small" prop="cid">
          <el-select
            placeholder="请选择模块"
            clearable
            size="small"
            v-model="form.cid">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in modulesList"
              :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专题类型:" style="width: 480px" size="small" prop="sectionType">
          <el-select
            placeholder="请选择专题类型"
            clearable
            size="small"
            v-model="form.sectionType">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in sectionTypes"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="专题名称:"
          size="small"
          prop="name"
          style="width: 480px">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="数量限制:"
          prop="collectionLimit"
          style="width: 480px"
        >
          <el-input v-model.number="form.collectionLimit"></el-input>
        </el-form-item>
        <el-form-item label="专题样式:" style="width: 480px" size="small" prop="showType">
          <el-select
            placeholder="请选择专题样式"
            clearable
            size="small"
            v-model="form.showType">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in showTypeList"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序:"
          prop="sortCode"
          style="width: 480px"
        >
          <el-input v-model.number="form.sortCode"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否推荐:"
          prop="isRecommend"
          style="width: 480px"
        >
          <el-select v-model="form.isRecommend" placeholder="请选择是否推荐">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in isRecommendes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否开启:"
          prop="status"
          style="width: 480px"
        >
          <el-select v-model="form.status" placeholder="请选择是否开启">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增到专题 -->
    <el-dialog
      title="添加"
      :visible.sync="addPlaylistDialogVisible"
      width="600px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form
        :model="addPlaylistForm"
        label-width="120px"
        :rules="addPlaylistRules"
        ref="addPlaylistForm"
      >
        <el-form-item
          label="ID:"
          size="small"
          prop="videoIDs"
          style="width: 480px"
        >
          <el-input
            type="textarea"
            rows="5"
            v-model="addPlaylistForm.videoIDs"
            placeholder="请输入ID，多个ID请用空格隔开"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onAddPlaySubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog
      title="详情"
      :visible.sync="playlistDialogVisible"
      width="1200px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <!--操作栏-->
      <div class="action-bar">
        <el-button
          type="warning"
          size="small"
          @click="batchDel"
          style="margin-right: 20px"
          >批量删除</el-button
        >
      </div>
      <el-table
        :data="playlistTableData"
        style="width: 100%"
        border
        v-loading="loading1"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        height="600"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="id" label="ID" align="center" width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.id || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
          min-width="360"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面图" align="center" width="160">
          <template slot-scope="scope">
            <span v-if="!scope.row.cover">暂无封面图</span>
            <div
              v-else
              class="picturePreview">
              <img-load
                style="width: 80px; height: 80px"
                :src="imgUrl + scope.row.cover"
                fit="fill"
              ></img-load>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 1">图集</el-tag>
            <el-tag type="success" v-else-if="scope.row.type == 2">视频</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="delPlaylist(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    var validateAmount = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("金额必须大于0"));
          } else {
            callback();
          }
        }
      }, 500);
    };
    return {
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      loading1: false,
      // 列表数据
      tableData: [],
      // 模块专题列表数据
      modulesList: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined, // 状态
        isRecommend: undefined, // 是否推荐
        id: undefined, // id
        name: undefined, // 专题名称
        cid: undefined, // 模块id
      },
      rules: {
        name: [
          { required: true, message: "请输入专题名称", trigger: "blur" },
        ],
        collectionLimit: [
          { required: true, validator: validateAmount, trigger: "blur" },
        ],
      },
      addPlaylistRules: {
        videoIDs: [
          { required: true, message: "请输入ID", trigger: "blur" },
        ],
      },
      statuses: [
        {
          label: "开启",
          value: 1,
        },
        {
          label: "关闭",
          value: 2,
        },
      ],
      isRecommendes: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      showTypeList: [
        { label: "六宫格", value: 1 },
        { label: "小三宫格横向滑动", value: 2 },
        { label: "大三宫格横向滑动", value: 3 },
        { label: "四宫格横行滑动", value: 4 },
        { label: "四宫格", value: 5 },
        { label: "三宫格方形头像", value: 6 },
        { label: "三宫格圆头像", value: 7 },
        { label: "排行榜", value: 8 },
        { label: "大二宫格横向滑动", value: 9 },
        { label: "二宫格方形头像", value: 10 },
      ],
      sectionTypes: [
        { label: "合集", value: 1 },
        { label: "排行榜", value: 2 },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: undefined, // 专题名称
        isRecommend: false, // 是否推荐
        collectionLimit: 0, // 数量限制
        sortCode: 0, // 排序
        status: 1, // 是否开启
        cid: undefined, // 模块id
        sectionType: undefined, // 专题类型
        showType: undefined, // 专题样式
      },
      addPlaylistDialogVisible: false,
      addPlaylistForm: {
        cIds: undefined, // ID
        videoIDs: undefined, // ID
        id: undefined, // 专题ID
        cid: undefined, // 模块id
        sectionType: undefined, //专题类型
        showType: undefined, // 专题样式
      },
      playlistDialogVisible: false,
      // 列表数据
      playlistTableData: [],
      // 当前专题ID
      currentPlaylistSectionId: undefined,
      videoIds: [],
    };
  },
  created() {
    this.getList();
    this.getSectionList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getPlaylistSectionList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            if (this.playlistDialogVisible) {
              this.tableData.forEach((item) => {
                if (item.id == this.currentPlaylistSectionId) {
                  this.playlistTableData = item.collections || [];
                }
              });
            }
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //查询模块列表数据
    getSectionList() {
      var params = {
        pageNumber: 1,
        pageSize: 1000,
      };
      API.getAllModulesSection(params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.modulesList = res.data;
          } else {
            this.modulesList = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.isRecommend = param.isRecommend;
        this.form.collectionLimit = param.collectionLimit;
        this.form.sortCode = param.sortCode;
        this.form.status = param.status;
        this.form.cid = param.cid;
        this.form.sectionType = param.type;
        this.form.showType = param.showType;
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addPlaylistSection(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updatePlaylistSection(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>配置, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPlaylistSection(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    delPlaylist(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: this.currentPlaylistSectionId,
            cIds: [param.id],
          };
          API.delSectionPlaylist(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    batchDel() {
      if (!(this.videoIds && this.videoIds.length))
        return this.$message.error("请至少选择一条数据");
      const videoIds = this.videoIds.map((item) => item.id);
      this.$confirm(`确认是否删除这些, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let delData = {
            id: this.currentPlaylistSectionId,
            cIds: videoIds,
          };
          API.delSectionPlaylist(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 打开添加窗口
    openAddPlaylist(item) {
      this.addPlaylistDialogVisible = true;
      this.addPlaylistForm.id = item.id;
    },
    onAddPlaySubmit() {
      this.$refs["addPlaylistForm"].validate((valid) => {
        if (valid) {
          var videoIDs = this.addPlaylistForm.videoIDs
            .toString()
            .replace(/\s+/g, "\n");
          this.addPlaylistForm.cIds = videoIDs.split("\n");
          this.addPlaylistForm.videoIDs = "";
          API.addPlaylistToSection(this.addPlaylistForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    viewPlaylist(row) {
      this.loading1 = true;
      this.playlistTableData = row.collections || [];
      this.currentPlaylistSectionId = row.id;
      this.playlistDialogVisible = true;
      this.loading1 = false;
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.isRecommend = false;
      this.form.collectionLimit = 0;
      this.form.sortCode = 0;
      this.form.status = 1;
      this.form.cid = undefined;
      this.form.sectionType = undefined;
      this.addPlaylistForm.cIds = undefined;
      this.addPlaylistForm.videoIDs = undefined;
      this.addPlaylistForm.id = undefined;
      this.addPlaylistForm.cid = undefined;
      this.addPlaylistForm.sectionType = undefined;
      this.playlistTableData = [];
      this.dialogVisible = false;
      this.addPlaylistDialogVisible = false;
      this.playlistDialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    getShowTypeName(showType) {
      var showTypeName = "";
      for (const st of this.showTypeList) {
        if (showType === st.value) {
          showTypeName = st.label;
          break;
        }
      }
      return showTypeName;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
</style>
